const context = require.context('@public', false, /\.(svg|png|jpg|jpeg|webp)$/);

export default function getImageUrl(name) {
  if (!name) {
    name = 'redPin.svg'
  }
  return context(`./${name}`);
}
